const initialState = {
  isLogged: null,
  user: {},
};

export default initialState;